import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { BentoCategory } from "schemas/dashboard";

import { Template } from "features/Influencer/ContactList/schema";
import { OrganizationBulkSendSettings } from "features/Influencer/Discover/Results/DiscoverFilter/AutomationVA/UpcomingPitchScheduleDialog/schema";

import EmailBoost from "../EmailBoost";
import GeneralSettings from "./GeneralSettings";

interface IProps {
  bulkSendSetting: OrganizationBulkSendSettings;
  setBulkSendSetting: Dispatch<
    SetStateAction<OrganizationBulkSendSettings | null>
  >;
  fallbackTemplates: Template[];
  setFallbackTemplates: Dispatch<SetStateAction<Template[]>>;
  categoriesToPickFrom: BentoCategory[];
}

export enum NicheTab {
  all = "all",
  active = "active",
}

export default function VASettings({
  bulkSendSetting,
  fallbackTemplates,
  setFallbackTemplates,
  setBulkSendSetting,
}: IProps) {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box sx={{ p: 2, pb: { xs: 10, md: 2 } }}>
      <GeneralSettings
        bulkSendSetting={bulkSendSetting}
        setBulkSendSetting={setBulkSendSetting}
        setFallbackTemplates={setFallbackTemplates}
        fallbackTemplates={fallbackTemplates}
      />
      {!isMobileScreen && <EmailBoost />}
    </Box>
  );
}
